export default __webpack_public_path__ + "static/media/card3200.92b73b0b.jpg";